import React from 'react';
import { Button, Grid, Row, Cell, Paragraph } from '@dexma/ui-components';
import { StyledConfirmActionModal } from 'adapter/in/common/components/ConfirmActionModal/style';
import i18n from 'asset/translation';
import ServerErrorAlert from 'adapter/in/dashboards/components/ServerErrorAlert';

const ConfirmChangesModal = ({
    isOpen,
    onClose,
    onProceed,
    onSaveAndProceed,
    message,
    title,
    proceedButtonText,
    saveAndProceedButtonText,
    proceedButtonVariant,
    dataIdContext,
    isLoading,
    hasError,
}: {
    isOpen: boolean;
    onClose: () => void;
    onProceed: () => void;
    message: string;
    title: string;
    proceedButtonText: string;
    onSaveAndProceed?: () => void;
    saveAndProceedButtonText?: string;
    proceedButtonVariant?: string;
    dataIdContext?: {
        saveAndProceed?: string;
        proceed: string;
        cancel: string;
        tryAgain: string;
    };
    isLoading?: boolean;
    hasError?: boolean;
}) => {
    const handleConfirm = () => {
        onProceed();
        onClose();
    };

    const footer = (
        <div data-testid='confirmActionModal'>
            {onSaveAndProceed && (
                <Button
                    variant='primary'
                    text={saveAndProceedButtonText}
                    isLoading={isLoading}
                    data-testid='save-and-proceed'
                    onClick={isLoading ? undefined : onSaveAndProceed}
                    dataId={dataIdContext?.saveAndProceed}
                />
            )}
            <Button
                variant={proceedButtonVariant || 'primary'}
                text={proceedButtonText}
                type='button'
                isLoading={isLoading}
                data-testid='proceed'
                onClick={isLoading ? undefined : handleConfirm}
                dataId={dataIdContext?.proceed}
            />
            <Button
                variant='secondary'
                text={i18n.t('common.cancel')}
                data-testid='cancel'
                onClick={onClose}
                dataId={dataIdContext?.cancel}
            />
        </div>
    );

    return (
        <StyledConfirmActionModal
            width={600}
            open={isOpen}
            onCancel={onClose}
            title={title}
            hasSaveAndProceedButton={!!onSaveAndProceed}
            footer={footer}
        >
            <Grid fluid className='no-padding-grid' data-testid='confirm-changes-modal'>
                <Row>
                    {hasError && (
                        <Cell>
                            <ServerErrorAlert tryAgain={() => onProceed()} dataId={dataIdContext ? dataIdContext.tryAgain : ''} />
                        </Cell>
                    )}
                </Row>
                <Row>
                    <Cell xs={12}>
                        <Paragraph margin='1rem 0rem 0rem 0'>{message}</Paragraph>
                    </Cell>
                </Row>
            </Grid>
        </StyledConfirmActionModal>
    );
};

export default ConfirmChangesModal;
